import { DxFormControl } from '../form-control';
import { checkIfControlIsAlreadyPresentByName } from './helpers';
import { CONTROL_METADATA_KEY } from './metadata-keys';
import { DxFormControlDefinition } from './interfaces';
import { addToMetadata } from '@digitaix/helpers';

export const DEFAULT_CONTROL_DEFINITION: Partial<
  DxFormControlDefinition<any>
> = {
  validators: [],
  readonly: false,
  disabled: false,
  required: false,
  userDefinedProperties: {},
  boxed: false,
  control: DxFormControl,
  fxFlex: 'nogrow',
  fxHide: false
};

export function Control(
  definition: Partial<DxFormControlDefinition<any>> = {}
) {
  return function(target: any, propertyKey: string) {
    definition = {
      ...DEFAULT_CONTROL_DEFINITION,
      name: propertyKey,
      propertyKey,
      ...definition
    };
    if (
      checkIfControlIsAlreadyPresentByName(
        CONTROL_METADATA_KEY,
        target,
        definition.name
      )
    ) {
      throw new Error(
        `[Control::${propertyKey}] A Control with name '${
          definition.name
        }' is already defined`
      );
    }
    addToMetadata(CONTROL_METADATA_KEY, definition, target);
  };
}
